import React from "react";
import { useAuth } from "../contexts/AuthContext";
import { Mail, User, Shield } from "lucide-react";

const ProfileRow = ({ label, value }) => (
  <div className="grid grid-cols-3 gap-4 py-3">
    <div className="text-sm text-gray-500">{label}</div>
    <div className="col-span-2 font-medium text-gray-800 break-words">
      {value || "—"}
    </div>
  </div>
);

const ProfilePage = () => {
  const { currentUser, userProfile } = useAuth();

  const name = `${userProfile?.firstName || ""} ${
    userProfile?.lastName || ""
  }`.trim();

  return (
    <div className="min-h-screen bg-gray-50">
      <header className="page-header">
        <div className="container-custom py-4">
          <h1 className="text-2xl font-bold text-gray-800">Mon Profil</h1>
          <p className="text-gray-600">Informations de votre compte</p>
        </div>
      </header>

      <main className="container-custom py-8">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
          <div className="card">
            <div className="flex items-center gap-4">
              <div className="w-16 h-16 rounded-full bg-gray-200 text-gray-700 flex items-center justify-center text-xl font-semibold">
                {(name || currentUser?.email || "U").slice(0, 2).toUpperCase()}
              </div>
              <div>
                <h2 className="text-xl font-semibold text-gray-900">
                  {name || currentUser?.email}
                </h2>
                <div className="flex items-center gap-2 text-sm text-gray-600">
                  <Shield className="w-4 h-4" />
                  <span>Rôle: {userProfile?.role || "—"}</span>
                </div>
              </div>
            </div>
            <div className="divider" />
            <div>
              <ProfileRow label="Prénom" value={userProfile?.firstName} />
              <ProfileRow label="Nom" value={userProfile?.lastName} />
              <ProfileRow label="Email" value={currentUser?.email} />
              {/* Placeholder pour téléphone si vous l'ajoutez plus tard */}
            </div>
          </div>

          <div className="lg:col-span-2 card">
            <h3 className="text-lg font-semibold mb-4">Sécurité</h3>
            <p className="text-sm text-gray-600 mb-4">
              Pour la réinitialisation du mot de passe, utilisez la fonction «
              Mot de passe oublié » depuis la page de connexion.
            </p>
            <a
              href="/login"
              className="btn-secondary inline-flex items-center gap-2"
            >
              <Mail className="w-4 h-4" /> Aller à la connexion
            </a>
          </div>
        </div>
      </main>
    </div>
  );
};

export default ProfilePage;
